import styled from 'styled-components/macro';
import theme from '../../../core/theme';

const Background2 = styled.div`
  background-color: ${theme.background2};
  position: fixed;
  height: 100vh;
  width: 100vw;
  z-index: -10;
`;

export default Background2;
